import { merge } from "lodash";
import Button from "./Button";
import Select from "./Select";
import SvgIcon from "./SvgIcon";

export default function ComponentsOverrides(theme) {
  return merge(Button(theme), Select(theme), SvgIcon(theme));
}
